import { Navigate, useParams } from 'react-router';
import { LangSwitch } from '../comp/chooseLang/ChooseLang';
import type { PageContent } from '../comp/chooseLang/ChooseLang';
import './Global.css'
import ProjectsViewer from '../comp/projectsViewer/ProjectsViewer';

function Projects() {
    var { id } = useParams();
    if (id != null) {
        return <Navigate to={'/projects/unavailable'} />;
    }

    const pageContentPl: PageContent[] = [
        {
            header: 'Projekty', type: 'full-title', content: '', custom: null
        },
        {
            header: '', type: 'custom', content: '', custom: <ProjectsViewer Projects={
                [
                    {
                        Title: 'B3 Game Engine',
                        WorkName: 'b3-ge',
                        DescShort: 'Modularny silnik gier z systemem refleksji i backendem renderowania opartym na Vulkanie. Zawiera własny, wieloplatformowy system zarządzania oknami i wejściem.',
                        Link: 'b3',
                        PromoImg: 'b3-static-promo.webp',
                        PromoGif: 'b3-promo.gif',
                    },
                    {
                        Title: 'Zarządzanie magazynem',
                        WorkName: 'warehouse',
                        DescShort: 'Stworzone przy użyciu Swinga. Dynamicznie obsługuje łatwo rozszerzalne klasy produktów oraz zapisuje je do pliku CSV i odczytuje z niego.',
                        Link: 'warehouse',
                        PromoImg: 'jv-promo.png',
                        PromoGif: null
                    },
                    {
                        Title: 'Ascii Raycaster',
                        WorkName: 'raycaster',
                        DescShort: 'Raycaster w wierszu poleceń, rysujący obraz znakami ASCII.',
                        Link: 'raycaster',
                        PromoImg: 'ray-promo.jpg',
                        PromoGif: null
                    }
                ]
            } />
        },
    ];
    const pageContentEn: PageContent[] = [
        {
            header: 'Projects', type: 'full-title', content: '', custom: null
        },
        {
            header: '', type: 'custom', content: '', custom: <ProjectsViewer Projects={
                [
                    {
                        Title: 'B3 Game Engine',
                        WorkName: 'b3-ge',
                        DescShort: 'Modular game engine with reflection system and Vulkan rendering backend. Implements custom crossplatform windowing/input managment system',
                        Link: 'b3',
                        PromoImg: 'b3-static-promo.webp',
                        PromoGif: 'b3-promo.gif',
                    },
                    {
                        Title: 'Warehouse Managment',
                        WorkName: 'warehouse',
                        DescShort: 'Made with Swing. Dynamicaly handles easly implementable products class and saves/reads them to/from csv file.',
                        Link: 'warehouse',
                        PromoImg: 'jv-promo.png',
                        PromoGif: null
                    },
                    {
                        Title: 'Ascii Raycaster',
                        WorkName: 'raycaster',
                        DescShort: 'ASCII Command line raycaster.',
                        Link: 'raycaster',
                        PromoImg: 'ray-promo.jpg',
                        PromoGif: null
                    }
                ]
            } />
        },
    ];

    var m = new Map<string, PageContent[]>();
    m.set('en', pageContentEn);
    m.set('pl', pageContentPl);

    return (
        <>
            <LangSwitch LangMap={m} />
        </>
    );
};

export default Projects;
